import { Link } from "react-router-dom";
import { Box, Button, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";

import ProtectedImageEmbed from "../../BusinessAttributes/ProtectedImageEmbed";
import APICompany from "../../../types/APICompany";
import Attribute from "../../BusinessAttributes/Attribute";

function BusinessSummaryAttributes({ company }: { company: APICompany }) {
  return (
    <>
      {company.name && (
        <Attribute label="Company Name">{company.name}</Attribute>
      )}

      {company.domain?.screenshot?.fullpage_image_link && (
        <Attribute label="Homepage Screenshot">
          <Box sx={{ flexBasis: "100%", height: 300, overflow: "hidden" }}>
            <ProtectedImageEmbed
              src={company.domain?.screenshot?.fullpage_image_link || null}
              relayQueryParameters={null}
              relayRequestId={null}
            />
          </Box>
        </Attribute>
      )}
      {company.description && (
        <Box>
          <Attribute label="Description">{company.description}</Attribute>
        </Box>
      )}
      {company.industry?.primary_industry && (
        <Box>
          <Attribute label="Primary Industry">
            {company.industry.primary_industry}
          </Attribute>
        </Box>
      )}
      <Box display="flex" sx={{ flexWrap: "wrap", gap: 2 }}>
        {company.founded_year && (
          <Box sx={{ flexBasis: "45%" }}>
            <Attribute label="Founded year">{company.founded_year}</Attribute>
          </Box>
        )}
        {company.metrics?.estimated_annual_revenue_range && (
          <Box sx={{ flexBasis: "45%" }}>
            <Attribute label="Revenue">
              {company.metrics.estimated_annual_revenue_range}
            </Attribute>
          </Box>
        )}
        {company.metrics?.estimated_employee_count_range && (
          <Box sx={{ flexBasis: "45%" }}>
            <Attribute label="Employees">
              {company.metrics.estimated_employee_count_range}
            </Attribute>
          </Box>
        )}
        {company.formation_type && (
          <Box sx={{ flexBasis: "45%" }}>
            <Attribute label="Formation Type">
              {company.formation_type}
            </Attribute>
          </Box>
        )}
      </Box>
      {company.primary_address && (
        <Box display="flex" sx={{ flexWrap: "wrap", gap: 2 }}>
          {company.primary_address.city && (
            <Box sx={{ flexBasis: "45%" }}>
              <Attribute label="City">{company.primary_address.city}</Attribute>
            </Box>
          )}
          {company.primary_address.state_province && (
            <Box sx={{ flexBasis: "45%" }}>
              <Attribute label="State">
                {company.primary_address.state_province}
              </Attribute>
            </Box>
          )}
          {company.primary_address.country && (
            <Box sx={{ flexBasis: "45%" }}>
              <Attribute label="Country">
                {company.primary_address.country}
              </Attribute>
            </Box>
          )}
        </Box>
      )}
      <Box>
        <Button
          component={Link}
          to={`/search/${company.domain?.name}/most_recent`}
          size="small"
          target="_blank"
          rel="noreferrer"
          variant="outlined"
          sx={{ width: "100%" }}
        >
          See most recent web presence review
        </Button>
      </Box>
    </>
  );
}

export default function BusinessSummaryColumn({
  domain,
  company,
}: {
  domain: string;
  company: APICompany | null;
}) {
  return (
    <Box
      sx={{
        p: 4,
        backgroundColor: grey[200],
        height: "100%",
        display: "flex",
        flexDirection: "column",
        rowGap: 2,
      }}
    >
      {company ? (
        <BusinessSummaryAttributes company={company} />
      ) : (
        <Typography>
          No company information available. Run a web presence review to
          populate business details.
        </Typography>
      )}
      <Box>
        <Button
          component={Link}
          to={`/domain/${domain}?run=1`}
          size="small"
          target="_blank"
          rel="noreferrer"
          variant="outlined"
          sx={{ width: "100%" }}
        >
          Run a new web presence review
        </Button>
      </Box>
    </Box>
  );
}
